<div class="side-padding sm:px-0">
  <div class="p-5 pb-0 bg-white rounded-10 max-sm:p-3 max-sm:pb-0">
    <app-breadcrumbs></app-breadcrumbs>

    <nz-skeleton
      *ngIf="loader"
      [nzActive]="true"
      [nzLoading]="true"
      class="pb-4 max-sm:pb-2"
    >
    </nz-skeleton>

    <ng-container *ngIf="!loader && loading">
      <app-dashboard-football
        [info]="infoMatch"
        *ngIf="sportsServices.getSelectedSport() === 'Futbol'"
      ></app-dashboard-football>

      <app-dashboard-sports
        [info]="infoMatch"
        *ngIf="sportsServices.getSelectedSport() !== 'Futbol'"
      >
      </app-dashboard-sports>
    </ng-container>

    <div class="pt-4 max-sm:pt-2"></div>
    <ng-container *ngIf="!loader && loading">
      <app-tab-bar
        [selectedIndex]="optionsMenuSelected"
        filtersOptions="matchDetail"
        (selectedIndexChange)="menuSelected($event)"
      ></app-tab-bar>
    </ng-container>
  </div>

  <div class="pt-4 max-sm:pt-2" *ngIf="!loader && loading">
    <!-- Match Tab -->
    <ng-container *ngIf="optionsMenuSelected === 0">
      <div class="p-5 bg-white rounded-10">
        <app-tab-bar
          [selectedIndex]="optionsSubMenuSelected"
          filtersOptions="matchSummary"
          (selectedIndexChange)="submenuSelected($event)"
        ></app-tab-bar>
        <div class="pt-4 max-sm:pt-2">
          <!-- Summary Tab -->
          <ng-container *ngIf="optionsSubMenuSelected === 0">
            <app-summary-football
              [infoMatchSelected]="infoMatch"
              [params]="params"
              *ngIf="sportsServices.getSelectedSport() === 'Futbol'"
            >
            </app-summary-football>
            <app-summary-sports
              [infoMatchSelected]="infoMatch"
              *ngIf="sportsServices.getSelectedSport() !== 'Futbol'"
            >
            </app-summary-sports>
          </ng-container>
          <!-- Statics Tab -->
          <ng-container *ngIf="optionsSubMenuSelected === 1">
            <app-statistics [infoMatchSelected]="infoMatch"></app-statistics>
          </ng-container>
          <!-- Line-up Tab -->
          <ng-container *ngIf="optionsSubMenuSelected === 2">
            <app-lineup
              *ngIf="sportsServices.getSelectedSport() != 'Tenis'"
              class="mb-4"
              [infoMatchSelected]="infoMatch"
              [paramsSet]="params"
            >
            </app-lineup>
          </ng-container>
          <!-- Match Info Tab -->
          <ng-container *ngIf="optionsSubMenuSelected === 3">
            <app-info-match
              [information]="{
                referee: infoMatch.referee || null,
                venue: infoMatch.venue || null,
                environment: infoMatch.environment || null,
                statusCode: infoMatch.score.status.code
              }"
              [title]="'MatchInformation'"
            ></app-info-match>
          </ng-container>
        </div>
      </div>
    </ng-container>

    <!-- Match Odds -->
    <!-- <ng-container *ngIf="optionsMenuSelected === 1">
      <app-match-odds [isMatch]="true"></app-match-odds>
    </ng-container> -->

    <!-- H2H Tab -->
    <ng-container *ngIf="optionsMenuSelected === 1">
      <app-h2h [infoMatchSelected]="infoMatch"></app-h2h>
    </ng-container>

    <!-- STANDINGS Tab -->
    <ng-container *ngIf="optionsMenuSelected === 2">
      <app-standings-football
        *ngIf="sportsServices.getSelectedSport() === 'Futbol'"
        [idCompetition]="infoMatch.idCompetition"
      ></app-standings-football>
      <app-standings-sports
        *ngIf="sportsServices.getSelectedSport() !== 'Futbol'"
        [idCompetition]="infoMatch.idCompetition"
      ></app-standings-sports>
    </ng-container>
  </div>

  <div
    *ngIf="!loading && !loader"
    class="p-4 my-4 text-center bg-white font-roboto-700 text-blue-o-50 max-sm:p-3 rounded-6 max-sm:my-2"
  >
    {{ "NotAvalaibleInformation" | translate }}
  </div>
</div>
